module.exports = __webpack_public_path__ + "static/media/why_study_programming.24021047.svg";